import React from 'react';
import { Row, Col } from 'antd';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { UserManagementForm } from './../../../components/';
import {
  getUsers,
  getFailedCreatedUsers,
  getUserActionResponse,
  getLoadingStatus,
} from './../../../selectors/User';
import { getUser, getUserRoles } from './../../../selectors/Authentication';
import { getCompanies } from './../../../selectors/Company';
import { userCreate, userMassCreate, userEdit, userDelete } from './../../../actions/User';
import { clearActionResponse } from './../../../actions/Global';
import { isSpecificUser } from './../../../utility/AuthorityUtils';

class UserManagement extends React.Component {
  render() {
    return (
      <Row>
        <Col span={24}>
          <UserManagementForm
            user={this.props.user}
            users={this.props.users}
            isAdmin={isSpecificUser(this.props.user, ['ADMIN', 'SUPERUSER'])}
            failedCreatedUsers={this.props.failedCreatedUsers}
            userCreate={this.props.userCreate}
            userMassCreate={this.props.userMassCreate}
            userEdit={this.props.userEdit}
            userDelete={this.props.userDelete}
            userRoles={this.props.userRoles}
            isLoading={this.props.isLoading}
            companies={this.props.companies}
            actionResponse={this.props.userActionResponse}
            clearActionResponse={this.props.clearActionResponse}
          />
        </Col>
      </Row>
    );
  }
}

/**
 * Maps relevant store state to props for this component.
 * @param state to be handled
 * @returns {{user, users, userRoles, companies, isLoading, userActionResponse}} are values returned or
 * manipulated from the state before sent to this component.
 */
const mapStateToProps = (state) => {
  return {
    user: getUser(state),
    users: getUsers(state),
    failedCreatedUsers: getFailedCreatedUsers(state),
    userRoles: getUserRoles(state),
    companies: getCompanies(state),
    isLoading: getLoadingStatus(state),
    userActionResponse: getUserActionResponse(state),
  };
};

/**
 * Maps relevant store actions to props for this component.
 * @param dispatch actions to be handled.
 * @returns {{userCreate, userEdit, userDelete, clearActionResponse}}
 * are actions that are mapped to props for this component.
 */
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      userCreate: userCreate,
      userMassCreate: userMassCreate,
      userEdit: userEdit,
      userDelete: userDelete,
      clearActionResponse: clearActionResponse,
    },
    dispatch
  );
};

/**
 * Proptypes validates that the state props are of expected type.
 * @type {{userCreate: shim, userEdit: shim, userDelete: shim, clearActionResponse: shim, isLoading: shim,
 * user: shim, users: shim, userRoles: shim, companies: shim, userActionResponse: shim}}
 */
UserManagement.propTypes = {
  userCreate: PropTypes.func,
  userMassCreate: PropTypes.func,
  userEdit: PropTypes.func,
  userDelete: PropTypes.func,
  clearActionResponse: PropTypes.func,
  isLoading: PropTypes.bool,
  user: PropTypes.instanceOf(Map),
  users: PropTypes.instanceOf(List),
  failedCreatedUsers: PropTypes.instanceOf(List),
  userRoles: PropTypes.instanceOf(List),
  companies: PropTypes.instanceOf(List),
  userActionResponse: PropTypes.instanceOf(Map),
};

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
